import { EmployerRule, EmployerRuleCreationPayload } from '../../../api/employer-rules'
import {
  EmployerDayRuleInterval,
  EmployerWeekRuleInterval,
} from '../../../../../backend/src/services/resources/employer-rules/employer-rule.model'
import { InputFormula } from '../../../api/employer-rules'

/**
 * Props for the EmployerRulesForm component
 */
export interface EmployerRulesFormProps {
  employerRule?: EmployerRule
  employerId: string
}

/**
 * Form values type with proper typing for all fields
 */
export type FormValues = Partial<Omit<EmployerRuleCreationPayload, 'interval' | 'valuesInTime'>> & {
  interval: Partial<
    Omit<
      EmployerRuleCreationPayload['interval'],
      'min' | 'max' | 'minPath' | 'minFallback' | 'maxPath' | 'maxFallback' | 'inputFormula'
    >
  > & {
    min?: string
    max?: string
    minPath?: string
    minFallback?: string
    maxPath?: string
    maxFallback?: string
    minBoundsMode?: 'fixed' | 'dynamic'
    maxBoundsMode?: 'fixed' | 'dynamic'
    originOffset?: any
    daysOfWeek?: number[]
    useCalendarDays?: boolean
    inputFormula?: InputFormula | null
  }
  valuesInTime: Array<{
    value: string | number
    effectiveFrom: string
    effectiveTo?: string
  }>
  employerDataOptions?: {
    setDurationAsProportional?: boolean
    addToWorkedTotal?: boolean
  }
  /**
   * UI-only flag to enable/disable special periods filters section
   * Not sent to the API payload (handled in transformFormToPayload)
   */
  useSpecialPeriodsFilters?: boolean
  specialPeriods?: {
    types: string[]
  }
}

/**
 * Validation errors type
 */
export type ValidationErrors = Record<string, string>

/**
 * Props for ValuesInTimeSection component
 */
export interface ValuesInTimeSectionProps {
  values: FormValues['valuesInTime']
}

/**
 * Props for BoundsConfigSection component
 */
export interface BoundsConfigSectionProps {
  boundsType: 'min' | 'max'
  values: FormValues['interval']
}

/**
 * Interval input options type
 */
export type IntervalInputOption = {
  value: EmployerDayRuleInterval['inputFormula'] | EmployerWeekRuleInterval['inputFormula']
  label: string
}

/**
 * Option type for path selection
 */
export interface PathOption {
  value: string
  label: string
}
